import { Component, OnInit } from '@angular/core';
import { FlashMessagesService } from 'angular2-flash-messages/module';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { EconomicGroupService } from '../../service/economic-group.service';

export interface ConfirmModel {
	title: string;
	groupType: number;
	userID: string;
	userName: string;
	userDoc: string;
	userCode: string;
	userExposure: string;
	userCreditLimit: string;
}

@Component({
	selector: 'app-economic-group-create',
	templateUrl: './economic-group-create.component.html',
	styleUrls: ['./economic-group-create.component.scss'],
	providers: [EconomicGroupService],
})
export class EconomicGroupCreateComponent
	extends DialogComponent<ConfirmModel, boolean>
	implements ConfirmModel, OnInit
{
	title: string;
	groupType: number;
	userID: string;
	userName: string;
	userDoc: string;
	userCode: string;
	userExposure: string;
	userCreditLimit: string;

	public groupName;
	private errMessage: string;
	private relationList;
	private memberList = [];
	private newGroup;
	private relationID;
	private groupTypeDesc;
	private tempMember = {
		memberID: '',
		memberName: '',
		memberDoc: '',
		memberCode: '',
		memberCreditLimit: '',
		memberExposure: '',
		ExplodeGrupo: true,
		canRemove: true,
	};
	private editMode = false;
	private canSave = false;
	private canInclude = false;
	private userFinancialDetail;

	public cpfMask = [
		/\d/,
		/\d/,
		/\d/,
		'.',
		/\d/,
		/\d/,
		/\d/,
		'.',
		/\d/,
		/\d/,
		/\d/,
		'-',
		/\d/,
		/\d/,
	];
	public cnpjMask = [
		/\d/,
		/\d/,
		'.',
		/\d/,
		/\d/,
		/\d/,
		'.',
		/\d/,
		/\d/,
		/\d/,
		'/',
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		'-',
		/\d/,
		/\d/,
	];

	constructor(
		dialogService: DialogService,
		private economicGroupService: EconomicGroupService,
		private flashMessagesService: FlashMessagesService
	) {
		super(dialogService);
	}

	ngOnInit() {
		this.getUserFinancialDetail();

		if (this.groupType == 1) {
			this.groupTypeDesc = 'Limite de Crédito Compartilhado';
		} else if (this.groupType == 2) {
			this.groupTypeDesc = 'Limite de Crédito Individual';
		}

		this.getRelations();
	}

	mask(): any {
		return {
			mask: (value) => {
				value = value.replace(/[^\d]+/g, '');
				if (value.length < 12) return this.cpfMask;
				else return this.cnpjMask;
			},
		};
	}

	getUserFinancialDetail() {
		this.economicGroupService.getFinancialDetail(this.userCode).subscribe(
			(result) => {
				if (result.Result) {
					this.userFinancialDetail = result.Result;
					this.memberList.push({
						memberID: this.userID,
						memberName: this.userName,
						memberDoc: this.userDoc,
						memberCode: this.userCode,
						memberCreditLimit: this.userFinancialDetail.LC,
						memberExposure: this.userFinancialDetail.Exposicao,
						ExplodeGrupo: true,
						canRemove: false,
					});
				} else {
					this.memberList.push({
						memberID: this.userID,
						memberName: this.userName,
						memberDoc: this.userDoc,
						memberCode: this.userCode,
						memberCreditLimit: '',
						memberExposure: '',
						ExplodeGrupo: true,
						canRemove: false,
					});
				}
			},
			(error) => {
				console.log(error);
			}
		);
	}

	getFinancialDetail(userCode) {
		this.economicGroupService.getFinancialDetail(userCode).subscribe(
			(result) => {
				if (result.Result) {
					this.tempMember.memberCreditLimit = result.Result.LC;
					this.tempMember.memberExposure = result.Result.Exposicao;
				}
			},
			(error) => {
				console.log(error);
			}
		);
	}

	getRelations() {
		this.economicGroupService.getRelations(this.groupType).subscribe(
			(result) => {
				if (result.Result) {
					this.relationList = result.Result;
				}
			},
			(error) => {
				console.log(error);
			}
		);
	}

	cancel() {
		this.close();
	}

	canSaveGroup() {
		// Checa todas as condições para habilitar o botão de salvar o grupo
		if (
			this.memberList.length < 2 ||
			this.groupName == undefined ||
			this.groupName == '' ||
			this.relationID == undefined ||
			this.relationID == ''
		) {
			this.canSave = false;
		} else {
			this.canSave = true;
		}
	}

	onChangeGroupName() {
		this.groupName = this.groupName.replace(
			/[^A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ 0-9]/g,
			''
		);
		$('.group-name').val(this.groupName);
		this.canSaveGroup();
	}

	onChangeGroupRelation() {
		// Algum tipo de validação...
		this.canSaveGroup();
	}

	onSaveGroup() {
		if (this.groupName) {
			this.economicGroupService
				.checkEconomicGroupName(this.groupName)
				.subscribe(
					(result) => {
						if (result.Result == true) {
							this.errMessage = 'Nome de grupo ja cadastrado!';
						} else {
							this.saveGroup();
						}
					},
					(error) => {
						console.log(error);
					}
				);
		}
	}

	saveGroup() {
		var tempMemberList = [];

		this.memberList.forEach((member) => {
			tempMemberList.push({
				ID: member.memberID,
				Documento: member.memberDoc,
				ExplodeGrupo: member.ExplodeGrupo || false,
			});
		});

		this.newGroup = {
			Nome: this.groupName,
			ContaClientePrincipalID: this.userID,
			ClassificacaoGrupoEconomicoID: this.groupType,
			TipoRelacaoGrupoEconomico: this.relationID,
			Membros: tempMemberList,
		};

		this.economicGroupService.insertEconomicGroup(this.newGroup).subscribe(
			(result) => {
				if (result.Success) {
					this.result = true;
					this.flashMessagesService.show('Grupo salvo com sucesso!', {
						cssClass: 'alert-success',
						timeout: 6000,
					});
					this.close();
				} else {
					this.errMessage = result.Errors[0];
				}
			},
			(error) => {
				console.log(error);
			}
		);
	}

	deleteMember(i) {
		this.memberList.splice(i, 1);
		this.canSaveGroup();
	}

	addMember() {
		var memberTest = this.memberList.filter(
			(member) => member.memberID == this.tempMember.memberID
		);

		if (!memberTest[0]) {
			this.memberList.push(this.tempMember);
		}

		this.canInclude = false;
		this.tempMember = {
			memberID: '',
			memberName: '',
			memberDoc: '',
			memberCode: '',
			memberCreditLimit: '',
			memberExposure: '',
			ExplodeGrupo: true,
			canRemove: true,
		};

		this.canSaveGroup();
	}

	docChanged() {
		if (this.tempMember.memberDoc.replace(/[^\d]+/g, '').length == 11) {
			this.editMode = !this.getAccountClientByDoc();
		} else if (this.tempMember.memberDoc.replace(/[^\d]+/g, '').length == 14) {
			this.editMode = !this.getAccountClientByDoc();
		}
	}

	codChanged() {
		if (this.tempMember.memberCode.length == 10) {
			this.editMode = !this.getAccountClientByCod();
		}
	}

	codChangedEnterKey() {
		if (this.tempMember.memberCode.trim() != '') {
			this.editMode = !this.getAccountClientByCod();
			$('.member-code').blur();
		}
	}

	getAccountClientByCod() {
		this.economicGroupService
			.getAccountClientByCod(this.tempMember.memberCode)
			.subscribe(
				(result) => {
					if (result.Result && result.Result.length > 0) {
						this.canInclude = true;
						this.tempMember.memberID = result.Result[0].ID;
						this.tempMember.memberDoc = result.Result[0].Documento;
						this.tempMember.memberName = result.Result[0].Nome;
						this.tempMember.memberCode = result.Result[0].CodigoPrincipal;
						this.getFinancialDetail(this.tempMember.memberCode);
						this.tempMember.canRemove = true;
					} else {
						this.canInclude = false;
						this.tempMember.memberID = '';
						this.tempMember.memberDoc = '';
						this.tempMember.memberName = '';
						this.tempMember.memberCode = '';
						this.tempMember.memberCreditLimit = '';
						this.tempMember.memberExposure = '';
					}

					return this.canInclude;
				},
				(error) => {
					console.log(error);
				}
			);

		return false; // was true...
	}

	getAccountClientByDoc() {
		this.economicGroupService
			.getAccountClientByDoc(this.tempMember.memberDoc.replace(/[^\d]+/g, ''))
			.subscribe(
				(result) => {
					if (result.Result) {
						this.canInclude = true;
						this.tempMember.memberID = result.Result[0].ID;
						this.tempMember.memberDoc = result.Result[0].Documento;
						this.tempMember.memberName = result.Result[0].Nome;
						this.tempMember.memberCode = result.Result[0].CodigoPrincipal;
						this.getFinancialDetail(this.tempMember.memberCode);
						this.tempMember.canRemove = true;
					} else {
						this.canInclude = false;
						this.tempMember.memberID = '';
						this.tempMember.memberDoc = '';
						this.tempMember.memberName = '';
						this.tempMember.memberCode = '';
						this.tempMember.memberCreditLimit = '';
						this.tempMember.memberExposure = '';
					}

					return this.canInclude;
				},
				(error) => {
					console.log(error);
				}
			);

		return false; // didn't exist before...
	}
}



// WEBPACK FOOTER //
// ./src/app/economic-group/component/economic-group-create/economic-group-create.component.ts